import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useUserManagementContext } from '../../context';
import { MemberRow } from '../member-row';
import type { AddMemberFormContentProps as Props } from './types';

export const AddMemberFormContent = memo(({ className }: Props) => {
  const form = useFormContext();
  const { setMembers } = useUserManagementContext();
  const members = useFieldArray({
    name: 'members',
    control: form.control,
  });

  // const duplicateEmailError = useDuplicateEmailError(form);

  useEffect(() => {
    setMembers?.(members);
  }, [members.fields.length]);

  return (
    <Stack className={classnames('AddMemberFormContent', className)} gap={2}>
      <Stack gap={2}>
        {members.fields.map(({ id }, index) => (
          <MemberRow
            index={index}
            key={id}
            remove={members.fields.length > 1 && members.remove}
          />
        ))}
      </Stack>
      {/* <Grid
        container
        columns={24}
        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        {duplicateEmailError && (
          <Grid
            item
            md={12}
            sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Icon
                sxx={{ margin: 'auto' }}
                name="alert-fill"
                color="error.200"
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography color="error" variant="body4">
                You have entered the same email for more than one invited user.
                Please use different email for each of the members you want to
                invite
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid> */}
    </Stack>
  );
});

AddMemberFormContent.displayName = 'AddMemberFormContent';
